import request from '@/utils/request';
import { exportUrl } from '@/utils/index';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';
/**
 *  查询组织订单分页列表
 */
export function getOrgOrdersList(params) {
  return request({
    url: `/funteach/orgOrders/page`,
    method: 'get',
    params: params
  });
}
/**
 *  获取订单信息
 */
export function getOrgOrdersInfo(params) {
  return request({
    url: `/funteach/orgOrders`,
    method: 'get',
    params: params
  });
}
// 导出组织订单
export function exportOrgOrdersExcel(options) {
  const url = exportUrl(options, '/funteach/orgOrders/export');
  return url;
}

// 组织订单模板下载
export function exportOrgOrdersTempate() {
  return `${ENVIRONMENT.BASE_API}/funteach/orgOrders/exportTempate?token=${getToken()}`;
}

/**
 *  新增订单
 */
export function addOrgOrders(options) {
  return request({
    url: `/funteach/orgOrders/add`,
    method: 'post',
    data: options
  });
}

/**
 *  更新订单
 */
export function updateOrgOrders(options) {
  return request({
    url: `/funteach/orgOrders/update`,
    method: 'post',
    data: options
  });
}

/**
 *  审核通过
 */
export function orgOrdersApprove(options) {
  return request({
    url: `/funteach/orgOrders/approve`,
    method: 'post',
    data: options
  });
}

/**
 *  审核不通过
 */
export function orgOrdersReject(options) {
  return request({
    url: `/funteach/orgOrders/reject`,
    method: 'post',
    data: options
  });
}

// 导入订单信息
export function importOrders() {
  return `${ENVIRONMENT.BASE_API}/funteach/orgOrders/importOrders`;
}

/**
 *  获取订单信息
 */
export function getOrganizationsTypes() {
  return request({
    url: `/funteach/organizations/types`,
    method: 'get'
  });
}
